<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button [disabled]="!habilitarNuevoProducto" type="button" class="btn btn-outline-success" title="Nuevo Producto" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo Producto</button>
            <button [disabled]="!habilitarGuardar" type="button" class="btn btn-outline-success" title="Nuevo Embalaje" (click)="onAddEmbalaje()"><i class="fa fa-file-o"></i> Nuevo Embalaje</button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" class="btn btn-outline-success" type="button" title="Guardar Equipamiento" (click)="guardarMatriculas()"><i class="fa fa-save"></i> Guardar Equipamiento</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Productos {{solicitudProductosEx?.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{solicitudProductosEx?.IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudProductosEx?.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{solicitudProductosEx?.IdEstadoSolicitudExDescripcion}}" />
                <img *ngIf="solicitudProductosEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudProductosEx?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudProductosEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudProductosEx?.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudProductosEx?.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudProductosEx?.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{solicitudProductosEx?.IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="solicitudProductosEx?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudProductosEx?.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudProductosEx?.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="row">
                    <!--GRID PRODUCTOS-->
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Lista de productos</strong>
                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="solicitudProductosEx?.TProductoSolicitudExCollection"
                                         [columns]="colsProds" sortField="CodigoTaric" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(solicitudProductosEx?.TProductoSolicitudExCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Grupo' && col.field!=='IdFormaDescripcion' && col.field!=='Peso' && col.field!=='Volumen' && col.field!=='DeAtestacion')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="(col.field==='Grupo' || col.field==='IdFormaDescripcion')" ngbTooltip="{{ rowData[col.field] }}">
                                                    {{rowData[col.field] | truncate:[25, '...'] }}
                                                </span>

                                                <span *ngIf="(col.field==='Peso' || col.field==='Volumen')">
                                                    {{rowData[col.field] | number:'1.3-5':'es'}}
                                                </span>

                                                <span *ngIf="(col.field==='DeAtestacion')">
                                                    {{rowData[col.field] | siNo}}
                                                    <i *ngIf="!rowData[col.field]" class="fa fa-info-circle icono-info-tooltip" placement="top" ngbTooltip="Producto no incluido en sus atestaciones"></i>
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                    <div *ngIf="productoEditable">
                                                        <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                                class="btn btn-sm btn-warning">
                                                            <span class="fa fa-edit"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="!productoEditable">
                                                        <button (click)="onEdit(rowData)" type="button" title="Consultar"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-search"></span>
                                                        </button>
                                                    </div>

                                                    <div *ngIf="productoBorrable">
                                                        <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>
                                                        </button>
                                                    </div>

                                                    <div *ngIf="deAtestacion && rowData['DeAtestacion'] === true">
                                                        <img class="icono-info-grid-med" src="./assets/images/DeAtestacion.png" container="body" ngbTooltip="Este producto se hereda de una Atestación. Consulte los enlaces de la cabecera." />
                                                    </div>

                                                </div>

                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="numeroProductos === 0" class="empty-grid">
                                    No hay productos asociados a la solicitud
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!--EQUIPAMIENTO-->

                    <div class="col-md-4">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-plus"></i> <strong id="stPerfil">Equipamiento</strong>
                            </div>
                            <div class="card-body-detalle-bot125">
                                <div class="collapse group-filtros-0" id="collapsedEquipamiento" [ngbCollapse]="isCollapsedEquipamiento">
                                    <div class="row">
                                        <div class="col-md-12">

                                            <div class="form-group">
                                                <div class="input-group">

                                                    <!-- //Todo:agaro. 03052022. Quitamos la validación de que sea obligatorio al menos un equipamiento en la solicitud de Exportación  [ngClass]="{ 'required-field' : EsPuerto }"-->
                                                    <label class="col-form-label" for="">Matrícula / Nº Contenedor</label>

                                                    <div class="input-group">
                                                        <input formControlName="Matricula" name="Matricula" title="" class="form-control" id="inpDescripcion" type="text" value="">

                                                        <span class="input-group-btn">
                                                            &nbsp;<button [disabled]="!habilitarGuardar" name="btnAddMatricula" class="btn btn-list btn-secondary" type="button" title="Añade una Matrícula" (click)="onAddMatricula()"><i class="fa fa-plus"></i></button>
                                                        </span>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="col-md-12">

                                            <label class="cabeceraTablaDetalles">Matrículas / Nº Contenedor</label>
                                            <table class="table table-list table-sm table-0-marginbot">
                                                <!-- table-responsive -->
                                                <tbody>
                                                    <tr *ngFor="let item of solicitudProductosEx?.TSolicitudEquipamientoExCollection">
                                                        <td>
                                                            <div class="btn-group">
                                                                <div *ngIf="matriculaBorrable">
                                                                    <button (click)="onDeleteMatricula(item)" type="button" title="Eliminar"
                                                                            class="btn btn-sm btn-danger">
                                                                        <span class="fa fa-remove"></span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td scope="col" class="td-list">{{item.Matricula}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdPerfil','required')">
                                                * Debe añadir alguna matrícula / nº contenedor.
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!--GRID EMBALAJES-->
                    <div class="col-md-8">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Lista de embalajes</strong>
                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="solicitudProductosEx?.TwEmbalajesExCollection"
                                         [columns]="colsEmbs" sortField="CodigoTaric" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(solicitudProductosEx?.TwEmbalajesExCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='IdTaricEmbalajeDescripcion' && col.field!=='IdUnidadEmbalajeDescripcion')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="(col.field==='IdTaricEmbalajeDescripcion' || col.field==='IdUnidadEmbalajeDescripcion')" ngbTooltip="{{ rowData[col.field] }}">
                                                    {{rowData[col.field] | truncate:[60, '...'] }}
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                    <div *ngIf="productoEditable">
                                                        <button (click)="onEditEmbalaje(rowData)" type="button" title="Editar"
                                                                class="btn btn-sm btn-warning">
                                                            <span class="fa fa-edit"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="!productoEditable">
                                                        <button (click)="onEditEmbalaje(rowData)" type="button" title="Consultar"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-search"></span>
                                                        </button>
                                                    </div>

                                                    <div *ngIf="productoBorrable">
                                                        <button (click)="onDeleteEmbalaje(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>
                                                        </button>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="numeroEmbalajes === 0" class="empty-grid">
                                    No hay embalajes asociados a la solicitud
                                </div>
                            </div>
                            <!--CONTADOR DE BULTOS-->
                            <div *ngIf="numeroEmbalajes > 0" class="card-body-detalle-bot125">
                                <div class="col-md-2">
                                    <label class="col-form-label" for="inpDescripcion">Nº Total de Bultos</label>
                                    <input readonly name="TotalBultos" title="" class="form-control" id="inpNombre" type="text" value="{{numeroBultosTotales}}">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</form>
